export const HEADER_LIST = [
	'선택',
	'마켓',
	'아이디',
	'주문번호',
	'상품 주문번호',
	'도매사 주문번호',
	// "송장번호",
	'택배사/송장번호',
	'마켓주문상태',
	'주문일시',
	'상품관리코드',
	'수취인명',
	'결제금액',
];
